<template>
  <div id="app-index" ref="index">
    <div class="bannars" :style="'height: '+height">
      <div class="bannar-box">
        <div class="bannar-top">
          <div class="top-l" v-if="crumbNameShow">
            <p>{{crumbName}}</p>
            <h3>{{crumbTitle}}</h3>
          </div>
          <div class="top-r">
            <span>您的位置： {{location}}</span>
          </div>
        </div>
      </div>
    </div>

    <!--div class="navs">
      <div class="nav-box" v-show="liStyle!=8">
        <ul>
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="{active:liStatus==item.id}"
            @click="getStyle(item.id)"
          >{{item.title}}</li>
        </ul>
      </div>
    </div-->
  </div>
</template>
<script>
export default {
  props: {
    //英文面包屑名称
    crumbName: {
      type: String
    },
    location:{
      type:String,
      default:"首页 > 关于我们 > 顺丰公益基金会"
    },
    //中文面包屑名称
    crumbTitle: {
      type: String
    },
    crumbNameShow: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: "60px"
    },
  },
  data() {
    return {
      navList: [
        {
          id: 1,
          title: "首页",
          url: "/"
        },
        {
          id: 2,
          title: "关于我们",
          url: "/pageIndex"
        },
        {
          id: 3,
          title: "公益项目",
          url: "/pageIndex"
        },
        {
          id: 4,
          title: "最近动态",
          url: "/pageIndex"
        },
        {
          id: 5,
          title: "公益地图",
          url: "/pageIndex"
        },
        {
          id: 6,
          title: "信息公示",
          url: "/pageIndex"
        },
        {
          id: 7,
          title: "公益影像",
          url: "/pageIndex"
        },
        {
          id: 8,
          title: "志愿者协会",
          url: "/pageIndex"
        }
      ],
      liStatus: 1,
      liStyle: 1,
      searchStatus: true
    };
  },
  methods: {
    getStyle(id) {
      this.liStatus = id;
    },
    getId(id) {
      this.liStyle = id;
      // console.log(3333,this.liStyle)
    }
  },
  created() {
    this.liStyle = sessionStorage.getItem("index") || 1;
  }
};
</script>

<style lang="scss" scoped>
#app-index {
  width: 100%;
  background-color: #fff;
  // overflow: hidden;
}
.bannars {
  position: relative;
  .bannar-box {
    width: 1233px;
    background-color: #ffffff;
    border-bottom: 1px solid #eee;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    .bannar-top {
      position: relative;
      padding-left: 18px;
      display: flex;
      justify-content: space-between;
      // margin-bottom: 45px;
      .top-l {
        > p {
          font-size: 24px;
          font-weight: normal;
          color: #999999;
        }
        > h3 {
          font-size: 24px;
          font-weight: 500;
          color: #333;
        }
      }
      .top-r {
        > span {
          font-size: 14px;
          color: #999999;
          line-height: 59px;
        }
        > i {
          font-style: normal;
          font-size: 14px;
          color: #333;
          line-height: 59px;
        }
      }
    }
  }
}
.navs {
  width: 100%;
  background-color: #fff;
  .nav-box {
    max-width: 1300px;
    margin: 30px auto;
    > ul {
      display: flex;
      > li {
        list-style: none;
        padding: 8px 22px;
        border-radius: 19px;
        border: solid 1px #dddddd;
        font-size: 16px;
        color: #333333;
        margin-right: 18px;
        cursor: pointer;
        &.active {
          background-color: #e83a16;
          border-color: #e83a16;
          color: #fff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Public/miniCrumb.vue